import { motion, useScroll, useSpring } from 'framer-motion';

// A thin bar tied directly to document scroll progress — fills as you scroll down,
// empties as you scroll back up. useSpring just smooths the motion, it doesn't change direction.
export function ScrollProgressBar() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 300, damping: 40, mass: 0.2 });

  return (
    <motion.div
      style={{
        position: 'fixed', top: 0, left: 0, right: 0, height: 3, zIndex: 200,
        transformOrigin: '0%', scaleX,
        background: 'linear-gradient(90deg, #014ed2, #2ca342)',
      }}
    />
  );
}
